import { render, staticRenderFns } from "./ReceiveOwnerMaterialsForm.vue?vue&type=template&id=fa5e0d78"
import script from "./ReceiveOwnerMaterialsForm.vue?vue&type=script&lang=js"
export * from "./ReceiveOwnerMaterialsForm.vue?vue&type=script&lang=js"
import style0 from "./ReceiveOwnerMaterialsForm.vue?vue&type=style&index=0&id=fa5e0d78&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports